import React from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { shadow } from "theme/GlobalElements";
import { colors } from "theme/Theme";

interface JumbotronProps {}

const Jumbotron: React.FC<JumbotronProps> = ({ children }) => {
  return <JumbotronContainer>{children}</JumbotronContainer>;
};

const JumbotronContainer = styled.div`
  margin: 30px 0;
  background-color: ${colors.gray};
  border-radius: 5px;
  padding: 10px;
  ${shadow}

  @media only screen and (${device.laptop}) {
    margin: 30px 20px;
    padding: 20px;
  }
`;

export default Jumbotron;
